<!--column title-->
<p class="col-11 p-b-1 m-l-6"
   [class.s1]="!isLast"
   [class.s2]="isLast"
   *iCms="'header' of column; skipEmpty: true"></p>
<!-- links -->
<ul class="m-l-6 p-r-6 p-b-2">
    @for (item of column.links; track $index) {
    <li class="m-t-1"
        [toggle]="[toggleGroup + index, $index]">
        <div class="flex flex-justify-between">
            <href [link]="item.link">
                <span *iCms="'text' of item"></span>
            </href>
            @if (item.tabLinks.length > 0) {
            <i class="p-l-1 icon-down col-11 flex flex-middle"
               aria-hidden="true"
               [toggleClass]="'icon-up !icon-down'"
               [toggleClassBy]="[toggleGroup + index, $index]"></i>
            }
        </div>

        <ul class="p-l-3"
            [hideUp]="[toggleGroup + index, $index]">
            @for (tab of item.tabLinks; track $index) {
            <li class="m-t-1">
                <href [link]="tab.link">
                    <span *iCms="'text' of tab"></span>
                </href>
            </li>
            }
        </ul>
    </li>
    }
</ul>

<!-- shipping information-->
@if (isFirst) {
<div class="p-l-6 b-t p-t-1 p-b-1 pos-relative">
    <multisite-switch />
</div>
}